import type { TFunction } from 'i18next';

import type { User } from '@/api/auth';
import { adultValidator } from '@/helpers/validators';

export interface FullInformationFormApi {
  firstName: string;
  lastName: string;
  dateOfBirth?: {
    day: string;
    month: string;
    year: string;
  };
  mobilePhone: {
    code: string;
    number: string;
  };
  country: string;
  city: string;
  address: string;
  postalCode: string;
  state?: string;
  gender?: string;
}

export const checkCompleteUserInformation = (
  user?: User,
  requiresState?: boolean
) =>
  !!user?.firstName &&
  !!user?.lastName &&
  !!user?.dateOfBirth &&
  !!user?.mobilePhone &&
  !!user?.country &&
  !!user?.city &&
  (requiresState ? !!user?.state : true) &&
  !!user?.address &&
  !!user?.postalCode &&
  !!user?.gender;

export const hideEmail = (email?: string) =>
  email ? email.replace(/(\w{3})[\w.+-]+@([\w.]+\w)/, '$1***@$2') : null;

export const getIsFormProfileCompleted = (
  values: FullInformationFormApi,
  countryCode?: string,
  requiresState?: boolean
) => {
  const dateOfBirth = `${values.dateOfBirth?.day}/${values.dateOfBirth?.month}/${values.dateOfBirth?.year}`;

  return (
    !!values.firstName &&
    !!values.lastName &&
    !!values.dateOfBirth?.day &&
    !!values.dateOfBirth?.month &&
    !!values.dateOfBirth?.year &&
    !!values.mobilePhone?.code &&
    !!values.mobilePhone?.number &&
    !!values.country &&
    !!values.city &&
    (requiresState ? !!values.state : true) &&
    !!values.address &&
    !!values.postalCode &&
    !!values.gender &&
    !adultValidator(countryCode)(dateOfBirth)
  );
};

export const DEFAULT_GENDER = 'm';

export const getGenderOptions = (t: TFunction) => [
  {
    name: t('personal:male'),
    value: 'm',
  },
  {
    name: t('personal:female'),
    value: 'f',
  },
];

export const CONFIRM_EMAIL_DELAY = 60;
